import lrQuery from './_src/lrQuery.vue'

lrQuery.install = function(Vue) {
  Vue.component(lrQuery.name, lrQuery)
}

export default lrQuery